<template>
  <div id="container">
    <!-- 导航 -->
    <div class='nav'>
      <div class='left'>
        <router-link tag="div" to='/user/userinfo' class='right-btn2'>
          <p class='btn-text'>个人资料</p>
        </router-link>
      </div>
      <div class='right'>
        <div class="wx_cont" @click="bindWX" v-show="qrcodeUrl">
          <img src="@/assets/images/wxImg.png" alt="">
          <span>绑定微信</span>
        </div>
      </div>
    </div>
    <!-- 课程包内容 -->
    <div id="class-list">
      <swiper class="unit-swiper" :options="swiperOption">
        <swiper-slide
          v-for="(item, index) of packageList" 
          :key="index"
        >
          <div class="card" @click="packageClick(item)">
            <div class="card-img" :style="{backgroundImage:'url(' + item.poster + ')'}">
              <span v-if="item.type !== 'trial'">{{item.totalUnits}}课时</span>
            </div>
            <!-- <div class="card-img">
              <span v-if="item.type !== 'trial'">{{item.totalUnits}}课时</span>
            </div> -->
            <div class="card-info">
              <p class="info1">{{item.name.zh}}</p>
              <p class="info2" v-if="item.type == 'trial'">进入</p>
              <p class="info2" v-else>进入课程</p>
              <p class="info3">{{item.startDate}}-{{item.endDate}}</p>
              <p class="info4">{{item.timeDescription}}</p>
            </div>
            <!-- 课程包锁的状态 -->
            <div class="lock_cont" v-show="item.showLock">
              <img src="@/assets/images/lock.png" alt="">
            </div>
          </div>
        </swiper-slide>
        <div
          class="swiper-pagination"
          ref="swiperPag"
          v-show="swiperOptionHide == true"
          slot="pagination"
        ></div>
        <div class="swiper-button-prev" v-show="swiperOptionHide == true" slot="button-prev"></div>
        <div class="swiper-button-next" v-show="swiperOptionHide == true" slot="button-next"></div>
      </swiper>


      <!-- <ul @mousedown.stop.prevent='classListMove' ref="classList">
        <li v-for="(item, index) of packageList" :key="index">
          <div class="card" @click="packageClick(item)">
            <div class="card-img" :style="{backgroundImage:'url(' + item.poster + ')'}"></div>
            <div class="card-info">
              <p class="info1">{{item.name.zh}}</p>
              <p class="info2" v-if="item.type == 'trial'">进入</p>
              <p class="info2" v-else>{{item.totalUnits}}节</p>
              <p class="info3">{{item.startDate}}-{{item.endDate}}</p>
              <p class="info4">{{item.timeDescription}}</p>
            </div>
            <div class="lock_cont" v-show="item.showLock">
              <img src="@/assets/images/lock.png" alt="">
            </div>
          </div>
        </li>
      </ul>
      <div class="block ul-bar">
        <el-slider v-model = "sliderValue" :show-tooltip = "false"></el-slider>
      </div> -->
      <!-- <div id="left"  @mousemove="leftmove" @mouseenter="leftoverHandler" @mouseleave="leftrightHandler"></div>
      <div id="right" @mousemove="rightmove" @mouseenter="rightoverHandler" @mouseleave="leftrightHandler"></div> -->
    </div>
    <!-- 绑定微信弹窗 -->
    <div class="wx_dialog" v-show="dialogVisible">
      <div class="wx_cont">
        <div class="wx_detail">
          <img src="@/assets/images/close.png" class="close_btn" @click="closeWx">
          <div class="qrcode">
            <img class="img2" :src="qrcodeUrl" alt="qrcode" />
            <!--<img src="@/assets/images/erweima.png" alt="">-->
            <p>请务必扫码以获得<br>上课及学习进度通知</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClassList",
  data () {
    return {
      count: 0,
      packageList: [],
      dialogVisible: false, // 二维码弹窗
      qrcodeUrl: '',
      pageId: '',
      clickLiIndex: -1,//course now clicked
      // sliderValue: 0,
      sliderBool: false, //sliderValue监听silderBar是否起作用
      mouseMoveX: 0,
      timer1: null,
      intervalTimer: null,
      timer2: null,
      leftClientX: 2,
      rightClientX: 2,
      showLock: false,
      nowDate: '',
      swiperOptionHide: true,
      // isShowMoblie: false, // 显示个人资料
      // isQrcode: false,
      waitingImgUrl: '',
      swiperOption: {   // swiper相关配置参数
        slidesPerView: "auto",
        spaceBetween: 30,
        slidesPerGroup: 4,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next"
        },
        resizeReInit: true,
        autoResize: true
      }
    }
  },
  watch: {
    // sliderValue (curVal,oldVal) {
    //   if(!this.sliderBool){
    //     let targetUl = this.$refs.classList;
    //     targetUl.style.left = -((curVal*(targetUl.offsetWidth-1000))/100) + 'px';
    //   }
    // },
    count(val){
      this.getPackagesList();
    },
    packageList(val){
      this.$nextTick(() => {
        let len = this.$refs.swiperPag.childNodes.length;
        this.swiperOptionHide = len <= 1 ? false : true;
      });
    }
  },
  created(){
    let that = this;
    this.getPackagesList();
    this.timer2 = setInterval(function() {
      that.count ++;
      console.log(that.count)
    },300000)
  },
  mounted () {
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.$router.push('/mobileclasslist');
    } else {
      // this.$router.push('/classlist');
    }
    
    this.axios.get(`/assox`).then((res) => {
      this.dialogVisible = true;
      this.qrcodeUrl = res.data.qrcode;
      this.pageId = res.data.pageId;
      this.probe();
    }).catch((error) => {
      this.dialogVisible = false;
      // this.isQrcode = true;
      console.log('error', error);
    });
   

    // 两分钟刷新
    var app = window.location.pathname;
    if (app == '/') app = '/index';
    this.intervalTimer = setInterval(function() {
      fetch('/heartbeat' + app, {
        credentials: 'same-origin'
      }).then(function(response){
        if (!response.ok) throw new Error('Heartbeat status code: ' + response.status);
        return response.text();
      }).then(function(commit) {
        if ((commit != vue_commit) && (commit != 'unknown')) {
          window.location.reload(true);
        }
      }).catch(function(error) {
        console.error(error)
      });
    }, 200000);

    localStorage.removeItem('packagetype');
  },
  beforeDestroy () {
    clearInterval(this.intervalTimer);
  },
  methods: {
    // 关闭微信绑定弹窗
    closeWx(){
      this.dialogVisible = false;
    },
    // 绑定微信
    bindWX(){
      this.dialogVisible = true;
    },
    // 获取课程包信息
    getPackagesList(){
      this.axios.get('/v1/api/self/packages').then((res) => {
        this.nowDate = new Date(res.headers.date).getTime(); // 服务器时间 开始时间
        this.packageList = res.data.packages;
        this.packageList.forEach((item) => {
          // console.log(item);
          let startTime = new Date(item.startDate);
          item.startDate = startTime.getMonth() + 1 + '月' + startTime.getDate()+'日';
          let endTime = new Date(item.endDate);
          item.endDate = endTime.getMonth() + 1 + '月' + endTime.getDate()+'日';
          // 如果存在lock字段 并且lockType为forever则永久显示锁 否则为过期锁 当服务器时间 > expires时间不可解锁 当服务时间 < expires时间则解锁
          if(item.lock){
            if(item.lock.lockType == 'forever'){
              item.showLock = true;
            }else if(item.lock.lockType == 'expiry'){
              if(this.nowDate > new Date(item.lock.expires).getTime()){
                item.showLock = true;
              }else if(this.nowDate < new Date(item.lock.expires).getTime()){
                item.showLock = false;
              }
            }
          }else{
            item.showLock = false;
          }
        });
      }).catch((error) => {
        console.log('error', error);
      });
    },
    probe () {
      this.axios.get(`/probe/${this.pageId}`,{ timeout: 5000 }).then((res) => {
        this.dialogVisible = false;
        this.$router.go(0);
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        }else{
          setTimeout(this.probe, 0);
        }
      });
    },
    // 点击课程包跳转
    packageClick (item) {
      if(this.mouseMoveX < 10){
        if((item.lock && this.nowDate > new Date(item.lock.expires).getTime()) || (item.lock && item.lock.lockType == 'forever')){
          return false
        }else{
          if(item.type == 'archived'){
            window.location.href = `/liveui#/recordedClass?packageId=${item._id}`;
          }else if(item.type == 'live'){
            window.location.href = `/liveui#/topClassLiving?packageId=${item._id}`;
          }else if(item.type == 'scratch/archived'){
            window.location.href = `https://scratch.jikestar.com/#/?packageId=${item._id}`;
            // this.axios.get("/whoami").then((res) => {
            //   let mobile = res.data.mobile;
            //   if(mobile){
            //     window.open(`http://localhost:8086/#/?packageId=${item._id}&mobile=${mobile}`);
            //   }
            // });
          }
        }
      }
    },
    // 卡片滑动事件
    // classListMove (e){
    //   let target = e.currentTarget;
    //   let disX = e.clientX - target.offsetLeft;
    //   document.addEventListener('mousemove', move);
    //   document.addEventListener('mouseup', up);
    //   let startClickX = e.clientX;
    //   let endClickX = -1;
    //   let _this = this;
    //   function move(e) {
    //     let left = e.clientX - disX;
    //     endClickX = e.clientX;
    //     if(left < 30 && left > -(target.offsetWidth-1000)){
    //       this.positionX = left;
    //       target.style.left =  left + 'px';
    //       _this.sliderBool = true;
    //       _this.sliderValue = (left*100)/-(target.offsetWidth-1000);
    //     }
    //   };
    //   function up(e) {
    //     _this.sliderBool = false;
    //     _this.mouseMoveX = endClickX === -1 ? 0 : Math.abs(endClickX - startClickX);
    //     document.removeEventListener('mousemove', move);
    //     document.removeEventListener('mouseup', up);
    //   }
    // },
    // rightoverHandler (e) {
    //   let targetUl = this.$refs.classList;
    //   clearInterval(this.timer1);
    //   this.timer1 = setInterval(() => {
    //     if(targetUl.offsetLeft <=  -(targetUl.offsetWidth-1000)){
    //       clearInterval(this.timer1);
    //     }else{
    //       this.sliderBool = true;
    //       this.sliderValue = targetUl.offsetLeft*100/-(targetUl.offsetWidth-1000);
    //       targetUl.style.left = targetUl.offsetLeft - this.rightClientX/10 + 'px';          
    //     }
    //   }, 30);
    // },
    // leftrightHandler () {
    //   this.sliderBool = false;
    //   clearInterval(this.timer1);
    // },
    // leftoverHandler (e) {
    //   let targetUl = this.$refs.classList;
    //   clearInterval(this.timer1);
    //   this.timer1 = setInterval(() => {
    //     if(targetUl.offsetLeft >=  0){
    //       clearInterval(this.timer1);
    //     }else{
    //       this.sliderBool = true;
    //       this.sliderValue = targetUl.offsetLeft*100/-(targetUl.offsetWidth-1000);
    //       targetUl.style.left = targetUl.offsetLeft + (10-this.leftClientX/8) + 'px';
    //     }
    //   }, 30);
    // },
    // leftmove (e){
    //   this.leftClientX = e.clientX;
    // },
    // rightmove (e){
    //   this.rightClientX = e.clientX-e.currentTarget.offsetLeft;
    // }
  }
};
</script>
<style lang="scss" scoped>
#container{
  width:100%;
  height: 100%;
  min-width: 1000px;
  min-height: 700px;
  background: #E5FFED;
  position: fixed;
  top: 0;
  left: 0;
  .waiting-box{
    padding-top: 100px;
    text-align: center;
    display: flex;
    justify-content: center;
    .img1{
      width: 600px;
    }
    .qrcode{
      color: #fff;
      margin-left: 50px;
      width: 220px;
      p{
        text-align: center;
        line-height: 100px;
      }
      .img2{
        width: 200px;
      }
      h2{
        margin-top: 100px;
        font-size: 30px;
      }
    }
  }
  .nav{
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    .left{
      display: flex;
      margin: 15px 24px 0 0;
      .right-btn2{
        width: 180px;
        height: 70px;
        background: url('~@/assets/images/personInfo.png') no-repeat;
        background-size: contain;
        margin: 7px 0 0 60px;
        cursor: pointer;
        position: relative;
        .btn-text{
          color: #fff;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          position: absolute;
          left: 73px;
          top: 20px;
        }
      }
    }
    .right{
      margin: 15px 35px 0px 0px;
      .wx_cont{
        width: 100px;
        text-align: center;
        cursor: pointer;
        img{
          width: 70px;
        }
        span{
          display: block;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #565656;
          line-height: 22px;
        }
      }
    }
  }
  #class-list {
  width: 100%;
  height: auto;
  margin-top: 90px;
  /* display: flex; */
  .swiper-container{
    display: flex;
    height: 440px;
    padding: 40px 50px;
    position: relative;
    .swiper-slide{
      width: 250px;
      height: 380px;
      transition: all 1s;
      &:hover {
        transform: scale(1.1);
        cursor: default;
      }
      .card {
        width:250px;
        height:380px;
        border-radius:19px;
        background: #fff;  
        position: relative; 
        display: flex;
        flex-direction: column;
        &:hover{
            .card-info {
              background: #FF9F00;
            }
            .card-info p{
              color: #fff;
            }
            .card-info .info2{
              background: #F38600!important;
            }
        }
        .card-img {
          width: 100%;
          height: 200px;
          border-radius:19px 19px 0 0;
          /* background: url('~@/assets/images/package3.png'); */
          background-size: cover;
          background-repeat: no-repeat;
          position: relative;
          span{
            display: block;
            width: 62px;
            height: 29px;
            text-align: center;
            line-height: 29px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 15px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            position: absolute;
            right: 15px;
            top: 15px;
          }
        }
        // 锁
        .lock_cont{
          width: 250px;
          height: 380px;
          border-radius: 19px;
          background: rgba(0, 0, 0, 0.4);
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          pointer-events: none;
        }
        .card-info {
          flex: 1;
          text-align: center;
          border-radius:0px 0px 19px 19px;
          background: #4BD7FF;
          .info1 {
            font-size: 19px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 27px;
            text-shadow: 0px 1px 2px rgba(0, 73, 123, 0.2);
            padding-top: 20px;
          }
          .info2 {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            width:74px;
            height:25px;
            line-height:25px;
            text-align: center;
            background: #00C1F8;
            border-radius: 14px;
            margin: 20px auto 10px;
            cursor:pointer;
          }
          .info3 {
            font-size: 16px;
            line-height: 22px;
            font-weight: 500;
            color: #FFFFFF;
          }
          .info4 {
            font-size: 16px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 22px;
            span {
              color: #ED6400;
            }
          }
        }
      }
    }
    /deep/.swiper-pagination-bullet{
      width: 12px!important;
      height: 12px!important;
    }
     /deep/.swiper-pagination-bullet-active{
      width: 36px!important;
      height: 12px!important;
      background: linear-gradient(90deg, #FEC93F 0%, #FDAA1A 100%)!important;
      border-radius: 7px!important;
    }
    .swiper-button-prev{
      width: 50px;
      height: 110px;
      background: url('~@/assets/images/left_btn.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -70px;
    }
    .swiper-button-next{
      width: 50px;
      height: 110px;
      background: url('~@/assets/images/right_btn.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -70px;
    }
  }
  .ul-bar {
    width: 400px;
    position: absolute;
    left: 50%;
    bottom: 100px;
    margin-left: -200px;
  }
  #left, #right {
    width: 100px;
    height: 100%;
    /* background: red; */
    position: absolute;
    top: 0;
  }
  #left {
    left: 0;
    cursor: w-resize;
  }
  #right {
    right: 0;
    cursor: e-resize;
  }

  /deep/ .el-progress-bar__inner {
    background-color: #61ACF1 !important;
  }
  /deep/ .el-progress-bar__outer {
    background-color: #baccf4 !important;
  }
  /deep/ .el-slider__bar {
    background-color: #fff !important;
  }
  /deep/ .el-slider__runway {
    background-color: #b8b7ed !important;
  }
  /deep/ .el-slider__button-wrapper {
    top: -53px !important;
  }
  /deep/ .el-slider__button {
    width: 45px !important;
    height: 73px !important;
    border: none !important;
    background: url('~@/assets/images/bar_mark.png') no-repeat !important;
    background-size: 100% 95% !important;
  }
  }
  .wx_dialog {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    .wx_cont{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .wx_detail{
        width: 600px;
        height: 450px;
        background: url("~@/assets/images/wxbg.png") no-repeat;
        background-size: contain;
        text-align: center;
        position: relative;
        .close_btn{
          width: 67px;
          position: absolute;
          right: -20px;
          top: -30px;
          cursor: pointer;
        }
        .qrcode{
          width: 210px;
          height: 267px;
          background: #FFFFFF;
          border-radius: 12px;
          border: 3px solid #FEBA28;
          margin: 60px auto 0px;
          padding: 10px 10px 20px 10px;
          text-align: center;
          img{
            height: 211px;
          }
          p{
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #474747;
            line-height: 25px;
            padding-top: 15px;
          }
        }
      }
    }
  }
}
@media (max-width: 1400px) {
  #class-list{
    margin-top: 20px!important;
    .swiper-container{
      height: 420px!important;
    }
  }
}
</style>

